// ─────────────────────────────────────────────────────────────────────────────
// Mock Invoice Data — matches shape of API_PATHS.INVOICE_LIST response
// Used in: Invoice.jsx
// Dates tuned to current period (April–May 2026) for live-looking screenshots.
// ─────────────────────────────────────────────────────────────────────────────

export const mockInvoiceListResponse = {
  rescode: 1,
  message: "Invoice list fetched successfully",
  data: {
    invoiceCount: 12,

    // Summary stat cards at top of Invoice page
    counts: [
      { title: "Total Revenue",      value: 348000, graph: "up",   change: "+18%" },
      { title: "Total Collected",    value: 284500, graph: "up",   change: "+14%" },
      { title: "Pending Payments",   value: 63500,  graph: "down", change: "-6%" },
      { title: "Discount Given",     value: 12400,  graph: "down", change: "-2%" },
      { title: "Invoices This Month", value: 22,    graph: "up",   change: "+22%" },
    ],

    // Category-wise breakdown for filters
    categories: ["Speech Therapy", "Occupational Therapy", "Physiotherapy", "Special Education", "ABA Therapy", "Art & Craft Therapy"],

    invoices: [
      {
        invoice_id: 1012,
        created_at: "2026-05-14T11:00:00.000Z",
        total_amount: 3500,
        paid_amount_sum: 2000,
        remaining_amount: 1500,
        Category: "Special Education",
        patient_name: "Navya Choudhary",
        patient_phone: "9812345670",
        payment_method: "Cash",
        invoice_payment_history: [{ is_full_amount_paid: 0 }],
      },
      {
        invoice_id: 1011,
        created_at: "2026-05-13T09:30:00.000Z",
        total_amount: 8500,
        paid_amount_sum: 8500,
        remaining_amount: 0,
        Category: "ABA Therapy",
        patient_name: "Riya Desai",
        patient_phone: "9801234567",
        payment_method: "Cash",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
      {
        invoice_id: 1010,
        created_at: "2026-05-11T14:30:00.000Z",
        total_amount: 6000,
        paid_amount_sum: 0,
        remaining_amount: 6000,
        Category: "Speech Therapy",
        patient_name: "Ishaan Mehta",
        patient_phone: "9890123456",
        payment_method: "",
        invoice_payment_history: [],
      },
      {
        invoice_id: 1009,
        created_at: "2026-05-09T10:00:00.000Z",
        total_amount: 15000,
        paid_amount_sum: 15000,
        remaining_amount: 0,
        Category: "Physiotherapy",
        patient_name: "Aditya Kumar",
        patient_phone: "9889012345",
        payment_method: "Online",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
      {
        invoice_id: 1008,
        created_at: "2026-05-06T11:45:00.000Z",
        total_amount: 11000,
        paid_amount_sum: 5500,
        remaining_amount: 5500,
        Category: "Occupational Therapy",
        patient_name: "Diya Kapoor",
        patient_phone: "9878901234",
        payment_method: "Online",
        invoice_payment_history: [{ is_full_amount_paid: 0 }],
      },
      {
        invoice_id: 1007,
        created_at: "2026-05-04T09:00:00.000Z",
        total_amount: 4500,
        paid_amount_sum: 4500,
        remaining_amount: 0,
        Category: "Art & Craft Therapy",
        patient_name: "Vivaan Joshi",
        patient_phone: "9867890123",
        payment_method: "Cash",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
      {
        invoice_id: 1006,
        created_at: "2026-05-01T13:30:00.000Z",
        total_amount: 7500,
        paid_amount_sum: 0,
        remaining_amount: 7500,
        Category: "Speech Therapy",
        patient_name: "Ananya Reddy",
        patient_phone: "9856789012",
        payment_method: "",
        invoice_payment_history: [],
      },
      {
        invoice_id: 1005,
        created_at: "2026-04-28T10:00:00.000Z",
        total_amount: 9000,
        paid_amount_sum: 9000,
        remaining_amount: 0,
        Category: "ABA Therapy",
        patient_name: "Kabir Singh",
        patient_phone: "9845678901",
        payment_method: "Online",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
      {
        invoice_id: 1004,
        created_at: "2026-04-24T14:00:00.000Z",
        total_amount: 6500,
        paid_amount_sum: 3000,
        remaining_amount: 3500,
        Category: "Special Education",
        patient_name: "Meera Gupta",
        patient_phone: "9834567890",
        payment_method: "Cash",
        invoice_payment_history: [{ is_full_amount_paid: 0 }],
      },
      {
        invoice_id: 1003,
        created_at: "2026-04-20T09:15:00.000Z",
        total_amount: 12000,
        paid_amount_sum: 12000,
        remaining_amount: 0,
        Category: "Physiotherapy",
        patient_name: "Rohit Patel",
        patient_phone: "9823456789",
        payment_method: "Online",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
      {
        invoice_id: 1002,
        created_at: "2026-04-15T11:00:00.000Z",
        total_amount: 8000,
        paid_amount_sum: 4000,
        remaining_amount: 4000,
        Category: "Occupational Therapy",
        patient_name: "Sneha Verma",
        patient_phone: "9812345678",
        payment_method: "Online",
        invoice_payment_history: [{ is_full_amount_paid: 0 }],
      },
      {
        invoice_id: 1001,
        created_at: "2026-04-10T10:30:00.000Z",
        total_amount: 5000,
        paid_amount_sum: 5000,
        remaining_amount: 0,
        Category: "Speech Therapy",
        patient_name: "Aryan Sharma",
        patient_phone: "9876543210",
        payment_method: "Cash",
        invoice_payment_history: [{ is_full_amount_paid: 1 }],
      },
    ],
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Mock Invoice Payment History — matches API_PATHS.INVOICE_PAYMENT_HISTORY
// Used in: Invoice.jsx handleClick (eye icon), Payment.jsx fetchPaymentHistory
// ─────────────────────────────────────────────────────────────────────────────

export const mockInvoicePaymentHistory = {
  rescode: 1,
  message: "Invoice payment history fetched successfully",
  data: {
    invoice: {
      invoice_id: 1002,
      tax: 0,
      total_paid_amount: 4000,
      remaining_amount: 4000,

      // Patient info — used in Payment.jsx
      patient_info: {
        patient_id: 102,
        patient_name: "Sneha Verma",
        date_of_birth: "2019-07-22",
        gender: "Female",
        mobile_number: "9812345678",
        date: "15 Apr, 2026",
        address: "45, Vaishali Nagar, Jaipur, Rajasthan",
      },

      // Session-wise breakdown — used in Payment.jsx (Added Sessions list)
      appointment_payment_history: [
        {
          id: 301,
          session_name: "Occupational Therapy",
          session_type: "Regular",
          total_appointment_count: 8,
          total_amount: 5600,
          total_discount_per: 0,
          total_discount_amount: 0,
          slot_time_str: "09:30 AM - 10:00 AM",
          doctor_info: {
            FirstName: "Rahul",
            LastName: "Meena",
          },
        },
        {
          id: 302,
          session_name: "Occupational Therapy",
          session_type: "Evaluation",
          total_appointment_count: 1,
          total_amount: 1200,
          total_discount_per: 5,
          total_discount_amount: 60,
          slot_time_str: "10:30 AM - 11:00 AM",
          doctor_info: {
            FirstName: "Rahul",
            LastName: "Meena",
          },
        },
        {
          id: 303,
          session_name: "Speech Therapy",
          session_type: "Follow-Up",
          total_appointment_count: 2,
          total_amount: 1000,
          total_discount_per: 0,
          total_discount_amount: 0,
          slot_time_str: "11:00 AM - 11:30 AM",
          doctor_info: {
            FirstName: "Dr. Neha",
            LastName: "Agarwal",
          },
        },
      ],

      // Already paid installments — used in Payment.jsx (Paid Payment History)
      paid_payment_hisotry: [
        {
          invoice_id: 1002,
          paid_amount: 4000,
          created_at: "2026-04-18T10:00:00.000Z",
          is_full_amount_paid: 0,
        },
      ],
    },
  },
};
